import styles from "./index.module.scss"

export const RouteNotFound = () => {
  return (
    <div>
      Route Not Found
    </div>
  )
}
